import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { siteStats } from "@/mocks/topics";

const quickTags = ["综艺改词", "直播翻车", "公关复盘", "剪辑争议", "音乐节取消"];

export default function Hero() {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");

  const goSearch = (value: string) => {
    const q = value.trim();
    navigate(q ? `/topics?q=${encodeURIComponent(q)}` : "/topics");
  };

  return (
    <section className="relative flex min-h-[620px] w-full items-center overflow-hidden md:min-h-[720px]">
      <img
        src="https://readdy.ai/api/search-image?query=Stylized%20abstract%20editorial%20artwork%20of%20layered%20torn%20paper%20and%20warm%20cream%20textures%20with%20soft%20vermillion%20and%20amber%20light%20streaks%2C%20faint%20ink%20brush%20marks%20and%20a%20subtle%20newspaper%20grid%20pattern%2C%20muted%20warm%20palette%2C%20calm%20sophisticated%20magazine%20cover%20atmosphere%2C%20generous%20negative%20space%20for%20text%20overlay&width=1800&height=1000&seq=hc-hero-01&orientation=landscape"
        alt="黑料吃话 话题文字实录与观察平台背景"
        title="黑料吃话 · 娱乐话题文字实录"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/35 to-black/50" />
      <div className="relative z-10 mx-auto w-full max-w-8xl px-4 pb-16 pt-32 md:px-8 md:pb-20 md:pt-40">
        <div className="max-w-3xl">
          <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3.5 py-1.5 text-xs tracking-[0.2em] text-white/90">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-400" />
            娱乐话题 · 文字实录 · 观察笔记
          </div>
          <h1 className="font-heading text-4xl font-black leading-tight text-white md:text-6xl">
            黑料吃话
            <span className="mt-3 block text-xl font-semibold leading-relaxed text-white/90 md:text-2xl">
              把一件事的前因后果，按顺序讲清楚
            </span>
          </h1>
          <p className="mt-6 max-w-2xl text-sm leading-relaxed text-white/80 md:text-base">
            我们整理娱乐与网络热点的完整文字版：事件时间线、双方往来对话、各方回应与观察笔记。
            不做碎片爆料，只把信息摆好，让你自己看清全貌。
          </p>

          <form
            className="mt-8 flex w-full max-w-xl flex-col gap-2 rounded-lg border border-white/20 bg-white/10 p-2 backdrop-blur sm:flex-row sm:items-center sm:rounded-full"
            onSubmit={(e) => {
              e.preventDefault();
              goSearch(keyword);
            }}
            role="search"
          >
            <span className="hidden h-9 w-9 shrink-0 items-center justify-center text-white/70 sm:flex">
              <i className="ri-search-line text-lg" />
            </span>
            <input
              type="search"
              name="q"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索话题、人物或事件关键词"
              aria-label="搜索话题"
              className="min-w-0 flex-1 bg-transparent px-3 py-2.5 text-sm text-white placeholder:text-white/60 focus:outline-none"
            />
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm text-background-50 transition-colors hover:bg-primary-600 sm:rounded-full"
            >
              开始检索
            </button>
          </form>

          <div className="mt-4 flex flex-wrap items-center gap-2">
            <span className="text-xs text-white/60">热门检索：</span>
            {quickTags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => goSearch(tag)}
                className="cursor-pointer rounded-full border border-white/25 px-3 py-1 text-xs text-white/80 transition-colors hover:border-white/60 hover:text-white"
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <dl className="mt-12 grid grid-cols-2 gap-6 border-t border-white/15 pt-8 md:mt-16 md:grid-cols-4 md:gap-8">
          {siteStats.map((stat) => (
            <div key={stat.label}>
              <dt className="font-heading text-2xl font-bold text-white md:text-3xl">{stat.value}</dt>
              <dd className="mt-1 text-xs text-white/65 md:text-sm">{stat.label}</dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}